import { combineReducers } from 'redux';
import welcomeCenterDoc from './welcomeCenterDoc';
import techDocReducer from './techDocReducer';
import arrayModel from './arrayModel';
import checklistSelectedItem from './checklistSelectedItem';

import toggleSideMenu from './toggleSideMenu';

export default combineReducers({
  welcomeCenterDoc,
  techDocReducer,
  // checklistReducer,
  arrayModel,
  checklistSelectedItem,
  toggleSideMenu,
});
